import type { DirectiveBinding } from 'vue'

export const vAutoFocus = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    if (!binding.hasOwnProperty('value') || binding.value) {
      el.focus()
    }
  },
}
